import { render, staticRenderFns } from "./trasladosCedis.vue?vue&type=template&id=d8ef944a"
import script from "./trasladosCedis.vue?vue&type=script&lang=js"
export * from "./trasladosCedis.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports